import React from 'react';
import { Link } from 'react-router-dom';
import LocalizationService from '../../application/services/LocalizationService';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const currentLanguage = LocalizationService.getCurrentLanguage();
  const isEnglish = currentLanguage === 'en';

  // Çeviri için basit yardımcı fonksiyon
  const t = (key: string): string => {
    return LocalizationService.translate(`footer.${key}`) as string || key;
  };

  // Sayfa linklerini düzgün ayarla
  const getLink = (path: string): string => {
    // URL yollarını kontrol et, gerekiyorsa düzelt
    return path.startsWith('/') ? path : `/${path}`;
  };

  return (
    <footer className="site-footer">
      <div className="footer-container">
        {/* About Us Bölümü */}
        <div className="footer-section">
          <h3 className="footer-heading">{t('aboutUs')}</h3>
          <ul className="footer-links">
            <li><Link to={getLink('about')}>{t('aboutGetSpeakHub')}</Link></li>
          </ul>
        </div>

        {/* Resources Bölümü */}
        <div className="footer-section">
          <h3 className="footer-heading">{t('resources')}</h3>
          <ul className="footer-links">
            <li><Link to={getLink('help')}>{t('helpCenter')}</Link></li>
            <li><Link to={getLink('signup')}>{t('signUp')}</Link></li>
            <li><Link to={getLink('terms')}>{t('termsOfUse')}</Link></li>
            <li><Link to={getLink('privacy')}>{t('privacyPolicy')}</Link></li>
            <li><Link to={getLink('community')}>{t('communityGuidelines')}</Link></li>
            <li><Link to={getLink('privacy-page')}>{t('privacy')}</Link></li>
            <li><Link to={getLink('cookies')}>{t('adCookiePolicy')}</Link></li>
            <li><Link to={getLink('schools')}>{t('wordFlashyForSchools')}</Link></li>
            <li><Link to={getLink('parents')}>{t('parents')}</Link></li>
          </ul>
        </div>

        {/* Language Bölümü */}
        <div className="footer-section">
          <h3 className="footer-heading">{t('language')}</h3>
          <div className="language-selector">
            <select
              value={currentLanguage}
              onChange={(e) => {
                LocalizationService.changeLanguage(e.target.value).then(() => {
                  // Dil değişikliğinin tüm uygulamaya yansıması için sayfayı yenile
                  window.location.reload();
                });
              }}
              className="language-select"
            >
              <option value="en">English</option>
              <option value="tr">Türkçe</option>
            </select>
          </div>
        </div>
      </div>

      {/* Country Bölümü */}
      <div className="country-section">
        <h3 className="footer-heading">{t('country')}</h3>
        <div className="countries-list">
          <a href="#" onClick={(e) => e.preventDefault()}>United States</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Canada</a>
          <a href="#" onClick={(e) => e.preventDefault()}>United Kingdom</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Australia</a>
          <a href="#" onClick={(e) => e.preventDefault()}>New Zealand</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Germany</a>
          <a href="#" onClick={(e) => e.preventDefault()}>France</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Spain</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Italy</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Japan</a>
          <a href="#" onClick={(e) => e.preventDefault()}>South Korea</a>
          <a href="#" onClick={(e) => e.preventDefault()}>India</a>
          <a href="#" onClick={(e) => e.preventDefault()}>China</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Mexico</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Switzerland</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Netherlands</a>
          <br />
          <a href="#" onClick={(e) => e.preventDefault()}>Brazil</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Poland</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Turkey</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Ukraine</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Taiwan</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Vietnam</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Indonesia</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Philippines</a>
          <a href="#" onClick={(e) => e.preventDefault()}>Russia</a>
        </div>
      </div>

      {/* Social Media Icons ve Copyright */}
      <div className="footer-social">
        <div className="social-icons">
          <a href="#" onClick={(e) => e.preventDefault()} className="social-icon tiktok-icon" aria-label="TikTok">TikTok</a>
          <a href="#" onClick={(e) => e.preventDefault()} className="social-icon twitter-icon" aria-label="X">X</a>
          <a href="#" onClick={(e) => e.preventDefault()} className="social-icon facebook-icon" aria-label="Facebook">Facebook</a>
          <a href="#" onClick={(e) => e.preventDefault()} className="social-icon instagram-icon" aria-label="Instagram">Instagram</a>
          <a href="#" onClick={(e) => e.preventDefault()} className="social-icon youtube-icon" aria-label="YouTube">YouTube</a>
          <a href="#" onClick={(e) => e.preventDefault()} className="social-icon linkedin-icon" aria-label="LinkedIn">LinkedIn</a>
        </div>
        <div className="copyright">
          <p>&copy; {currentYear} GetSpeakHub, Inc.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
